import React from "react";
import RequestorInformation from "../../../../features/bonds/shared/components/RequestorInformation";

export default function HistoricRequestorInformation(props) {
  return <RequestorInformation respectExistingData={false} {...props} />;
}
